import * as yup from 'yup';

const ExperienceData = {
  packageInitValues: {
    name: '',
    price: 0,
    discountedPrice: 0,
    adults: 0,
    kids: 0,
    desc: '',
    seatCustomized: false,
    status: true,
  },
  packageValidation: yup.object({
    name: yup
      .string()
      .required('Package Name is required')
      .min(1, 'Minimum 1 Character')
      .max(64, 'Maximum 64 Character'),
    price: yup
      .number()
      .positive('Price should be greater than "0"')
      .required('Price is Required'),
    adults: yup
      .number()
      .positive('Should be a greater than "0"')
      .required('Adult Count is Required'),
    kids: yup.number().required('Kids Count is Required'),
    desc: yup.string().max(500, 'Maximum 500 Characters'),
    discountedPrice: yup
      .number()
      .lessThan(
        yup.ref('price'),
        'Discount Price should be less than Price Value'
      ),
  }),

  initialValues: {
    category: '',
    subCategory: '',
    classification: [],
    expType: '',
    name: '',
    description: '',
    primary: false,
    startDate: '',
    endDate: '',
    copyTimings: false,
    copyAddress: true,
    timings: { days: [] },
    userBenefits: '',
    photos: [],
    photoThumbnails: [],
    tc: '',
    active: false,
    venueAddress: '',
    venue: { latitude: '', longitude: '' },
    vendorId: '',
    isKidsAllowed: false,
    serveFood: false,
    foodItems: '',
    minAge: 0,
    videos: [],
    tags: [],
    packages: [],
    isPackagesProvided: false,
    seatsBooked: 0,
    seatsLeft: 0,
    ticketName: '',
    adultPrice: 0,
    kidsPrice: 0,
    totalSeats: 0,
    minSeats: 0, // Seats for Booking
    maxSeats: 0, // Seats for Booking
    ticketDesc: '',
    refundDesc: '',
    addOnAvailable: false,
    addOnDesc: '',
    rescheduleAllowed: false,
    highchairAccess: false,
    handicapAccess: false,
    sameAddress: true,
    autoAccept: false,
    autoAcceptPax: 0,
    sameDayBooking: false,
    maxDaysAhead: '',
    bookingTimeSlot: '',
    autoCancel: '',
    seatingPreference: [],
  },
  validation: yup.object({
    name: yup
      .string()
      .required('Experience Name is required')
      .min(1, 'Minimum 1 Character')
      .max(64, 'Maximum 64 Character'),
    description: yup
      .string()
      .required('Description is required')
      .min(1, 'Minimum 1 Character')
      .max(512, 'Maximum 500 Character'),
    startDate: yup.string().required('Start Date is required'),
    // start_time: yup.string().required("Start Time is required"),
    endDate: yup.string().required('End Date is required'),
    // end_time: yup.string().required("End Time is required"),
    // coupon_code: yup
    //     .string()
    //     .required("Offer Code/Coupon Code is required")
    //     .min(1, "Minimum 1 Character")
    //     .max(15, "Maximum 15 Character"),
    totalSeats: yup
      .number()
      .positive()
      .min(1, 'Min Usage Limit must be greater than or equal to 1')
      .required('Maximum Usage Limit is required'),
    //   .moreThan(
    //     yup.ref("maxUsage"),
    //     "Maximum Usage Limit must be greater than Maximum Usage Limit for Entire Offer"
    //   ),
    useLimit: yup.number().required('User Usage Limit is required'),
    useFrequency: yup.string().required('Frequency is required'),
    maxUsage: yup
      .number()
      .positive()
      .required('Maximum Usage Limit for Entire offer is required')
      .min(
        1,
        'Maximum Usage Limit for Entire Offer must be greater than or equal to 1'
      )
      .lessThan(
        yup.ref('maxSeats'),
        'Maximum Usage Limit for Entire Offer must be less than Maximum Usage Limit'
      ),
    tc: yup
      .string()
      .required('Terms and Conditions are required')
      .min(1, 'Minimum 100 Character')
      .max(512, 'Maximum 512 Character'),
    adultPrice: yup
      .number()
      .positive()
      .typeError('Adult Ticket Price should be positive')
      .required('Adult ticket price is required'),
    kidsPrice: yup
      .number()
      .positive()
      .typeError('Kids Ticket Price should be positive')
      .required('Kids Ticket Price is required'),
    refundDesc: yup
      .string()
      .required('Refund and Cancellation is required')
      // .min(1, "Minimum 1 Character")
      .max(500, 'Maximum 500 Character'),
    photos: yup.array().min(1, 'At least one image should be uploaded'),
  }),

  f1initialValues: {
    category: '',
    subCategory: '',
    classification: [],
    expType: '',
    name: '',
    description: '',
    primary: false,
    startDate: '',
    endDate: '',
    copyTimings: false,
    copyAddress: false,
    timings: { days: [] },
    userBenefits: '',
    photos: [],
    photoThumbnails: [],
    tc: '',
    active: false,
    venueAddress: '',
    venue: { latitude: '', longitude: '' },
    vendorId: '',
    ageRestriction: false,
    serveFood: false,
    foodItems: '',
    minAge: 0,
    videos: [],
    tags: [],
    refundDesc: '',
  },

  f1validations: yup.object({
    category: yup.string().required('category is required'),
    subCategory: yup.string().required('subCategory is required'),
    classification: yup
      .array()
      .min(1, 'classification is required')
      .required('classification is required'),
    name: yup
      .string()
      .required('Experience Name is required')
      .min(1, 'Minimum 1 Character')
      .max(64, 'Maximum 64 Character'),
    description: yup
      .string()
      .required('Description is required')
      .min(1, 'Minimum 1 Character')
      .max(500, 'Maximum 500 Character'),
    userBenefits: yup.string().max(500, 'Maximum 500 Characters'),
    startDate: yup.string().required('Start Date is required'),
    endDate: yup.string().required('End Date is required'),
    tc: yup
      .string()
      .required('Terms and Conditions are required')
      .min(1, 'Minimum 100 Character')
      .max(500, 'Maximum 500 Character'),
    photos: yup.array().min(2, 'Atleast two image should be uploaded'),
    venueAddress: yup.string().when('copyAddress', {
      is: (val) => !val,
      then: yup
        .string()
        .required('Venue address is required')
        .min(1, 'Minimum 100 Character')
        .max(500, 'Maximum 500 Character'),
    }),
  }),

  f2initialValues: {
    seatsBooked: 0,
    allowSingleBooking: true,
    seatsLeft: 0,
    ticketName: '',
    adultPrice: 0,
    kidsPrice: 0,
    totalSeats: 0,
    minSeats: 0, // Seats for Booking
    maxSeats: 0, // Seats for Booking
    ticketDesc: '',
    packages: [],
    isPackagesProvided: false,
    refundDesc: '',
    addOnAvailable: false,
    addOnDesc: '',
    rescheduleAllowed: false,
  },

  f2validations: yup.object({
    adultPrice: yup.number().when('allowSingleBooking', {
      is: true,
      then: yup.number().positive().required('Adult price is required'),
    }),
    kidsPrice: yup.number().when('allowSingleBooking', {
      is: true,
      then: yup.number().required('Kids price is required'),
    }),
    totalSeats: yup
      .number()
      .positive()
      .min(1, 'Min Usage Limit must be greater than or equal to 1')
      .required('Maximum Usage Limit is required'),
    ticketDesc: yup.string().max(500, 'Max 500 Characters'),
    addOnDesc: yup.string().max(500, 'Max 500 Characters'),
    refundDesc: yup
      .string()
      .required('Refund & cancellation is required')
      .max(500, 'Max 500 Characters'),
    maxSeats: yup.number().when('allowSingleBooking', {
      is: true,
      then: yup
        .number()
        .moreThan(
          yup.ref('minSeats'),
          'Max seats should be more than min seats.'
        ),
    }),
  }),

  f3intialvalues: {
    highchairAccess: false,
    handicapAccess: false,
    sameAddress: true,
    autoAccept: false,
    autoAcceptPax: 0,
    sameDayBooking: false,
    maxDaysAhead: '',
    bookingTimeSlot: '',
    autoCancel: '5',
    seatingPreference: [],
  },
  f4intialvalues: {
    menuList: [],
  },
  f5intialvalues: {
    orderType: [],
    packagingCharges: 0,
  },
};

export default ExperienceData;
